export default "__VITE_ASSET__CzV8auLg__"